import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import { format } from "date-fns";
import GenericTableComponent from "../../components/common/Table";
import { getTopPublishers } from "../../redux/slices/reportSlice";
import { useNavigate } from "react-router-dom";
//import { convertToLocalCurrency } from '../../utils/currency';
import Swal from "sweetalert2";
const columns = [
  { id: "publishername", label: "Publisher" },
  { id: "totalcampaigns", label: "Campaigns" },
  { id: "ecpm", label: "eCPM" },
  { id: "conversionrate", label: "CR" },
  { id: "totalreach", label: "Clicks" },
  { id: "totalacquistion", label: "Conversions" },
  { id: "totalamountspent", label: "Amount" },
  { id: "hoardedconversions", label: "Hoarded conversions" },
  { id: "totalhoardedamount", label: "Hoarded amount" },
  { id: "totalentireconversion", label: "Total conversions" },
];
const supportColumns = [
  { id: "publishername", label: "Publisher" },
  { id: "totalcampaigns", label: "Campaigns" },
  //{ id: "ecpm", label: "eCPM" },
  { id: "conversionrate", label: "CR" },
  { id: "totalreach", label: "Clicks" },
  { id: "totalacquistion", label: "Conversions" },
  { id: "totalentireconversion", label: "Total conversions" },
  // { id: "totalamountspent", label: "Amount" },
  // { id: "hoardedconversions", label: "Hoarded conversions" },
  // { id: "totalhoardedamount", label: "Hoarded amount" },
];
const PublishersTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { topPublishers, metaP, loading } = useSelector((state) => state.report);
  //console.log(publishers)
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [dateRange, setDateRange] = useState(() => {
    const now = new Date();
    return {
      startDate: new Date(now.getFullYear(), now.getMonth(), 1),
      endDate: now,
    };
  });
  const [exportData] = useState(true)
  const [exportLoading, setExportLoading] = useState(false);
  const userRole = localStorage.getItem('userRole');

  useEffect(() => {
    const params = { page, rowsPerPage };

    if (dateRange.startDate && dateRange.endDate) {
      params.startDate = format(dateRange.startDate, "yyyy-MM-dd");
      params.endDate = format(dateRange.endDate, "yyyy-MM-dd");
    }

    if (searchFilter) {
      params.search = searchFilter;
    }

    dispatch(getTopPublishers(params))
  }, [dateRange, dispatch, page, rowsPerPage, searchFilter]);

  const handlePageChange = (event, newPage) => {
      setPage(newPage);
  };
  
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  
  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm) => {
        setSearchFilter(searchTerm);
        setPage(0);
      }, 2000),
    [setSearchFilter, setPage]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };
  
  const triggerSearch = () => {
    setSearchFilter(search);
    setPage(0);
  };
  
  const handleExport = async () => {
    try {
      setExportLoading(true);
      
      // Get current date and 7 days ago
      const endDate = dateRange.endDate 
        ? format(dateRange.endDate, "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd");
      
      const startDate = dateRange.startDate 
        ? format(dateRange.startDate, "yyyy-MM-dd")
        : format(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), "yyyy-MM-dd");
      
      const response = await 
      dispatch(getTopPublishers({startDate, endDate, exportData})).unwrap();

      // Get the file URL from the response
      if (response.data.file) {
        // Create a temporary link and trigger download
        const link = document.createElement('a');
        link.href = response.data.file;
        link.setAttribute('download', `Publisher-report.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        Swal.fire({
          title: 'Export Status',
          text: response.data.message || 'No file available for download',
          icon: 'info',
          confirmButtonColor: '#3730a3'
        });
      }
    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        title: 'Export Failed',
        text: error.message || 'Failed to export publisher details',
        icon: 'error',
        confirmButtonColor: '#3730a3'
      });
    } finally {
      setExportLoading(false);
    }
  };
  
  return (
    <div>
      {loading ? (
        <div> </div>
      ) : (
        <GenericTableComponent
          columns={userRole === 'SUPPORT' ? supportColumns : columns}
          data={topPublishers}
          filterSearch={true}
          paginate={true}
          viewLink="/publisher-campaigns"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={metaP?.itemCount || 0}
          setDateRange={setDateRange}
          dateRange={dateRange}
          //hideSearch
          hideActiveSearch
          reportView
          detailLink="/publisher-details"
          detailLinkText="View details"
          viewLinkText="View campaigns"
          showExport={true}
          onExport={handleExport}
          exportLoading={exportLoading}
          onRowClick={(row) => {
            const startDate = format(dateRange.startDate || new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), "yyyy-MM-dd");
            const endDate = format(dateRange.endDate || new Date(), "yyyy-MM-dd");
            navigate(`/publisher-details/${row.publisherreference}?startDate=${startDate}&endDate=${endDate}&name=${encodeURIComponent(row.publishername)}`,
            );
          }}
        />
      )}
    </div>
  );
};

export default PublishersTable;
